import { AddEditContractorCode } from "@/models/api/administration/contractors/AddEditContractorCode";
import { ContractorCode } from "@/models/api/administration/contractors/ContractorCode";
import CancellableHelper from "@/requests/CancellableHelper";

//#region routes
export const URL_GET_CONTRACTOR_CODES = "/ContractorAdministration/${ContractorId}/Code";
export const URL_GET_GENERATE_CONTRACTOR_CODE = "/ContractorCode/Generate";
export const URL_POST_ADD_CONTRACTOR_CODE = "/ContractorAdministration/${ContractorId}/Code/Add";
export const URL_POST_REMOVE_CONTRACTOR_CODE = "/ContractorCode/${ContractorCodeId}/Remove";
export const URL_POST_EDIT_CONTRACTOR_CODE = "/ContractorCode/${ContractorCodeId}/Edit";

//#endregion

const _getContractorCodes = new CancellableHelper<Array<ContractorCode>>(URL_GET_CONTRACTOR_CODES, ContractorCode);
export const getContractorCodes = async (contractorId: string): Promise<Array<ContractorCode>> => {
  return _getContractorCodes.get({ ContractorId: contractorId });
};

const _generateContractorCode = new CancellableHelper<number>(URL_GET_GENERATE_CONTRACTOR_CODE, Number);
export const generateContractorCode = async (): Promise<number> => {
  return _generateContractorCode.get();
};

const _addContractorCode = new CancellableHelper<number>(URL_POST_ADD_CONTRACTOR_CODE, Number);
export const addContractorCode = async (contractorId: string, body: AddEditContractorCode): Promise<number> => {
  return _addContractorCode.post({ ContractorId: contractorId }, body);
};

const _removeContractorCode = new CancellableHelper<null>(URL_POST_REMOVE_CONTRACTOR_CODE, null, true);
export const removeContractorCode = async (contractorCodeId: number): Promise<null> => {
  return _removeContractorCode.post({ ContractorCodeId: contractorCodeId });
};

const _editContractorCode = new CancellableHelper<null>(URL_POST_EDIT_CONTRACTOR_CODE, null, true);
export const editContractorCode = async (contractorCodeId: number, body: AddEditContractorCode): Promise<null> => {
  return _editContractorCode.post({ ContractorCodeId: contractorCodeId }, body);
};
